import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_LIST_TWEET_AD_STATUS = gql`
  query GetList($request: TweetAdStatusRequest!) {
    list: GetListTweetAdStatus(request: $request) {
      next_cursor
      data
    }
  }
`;

export const PREVIEW_TWEET_AD_STATUS = gql`
  query GetList($request: TweetAdStatusRequest!) {
    list: PreviewTweetAdStatus(request: $request) {
      next_cursor
      data
    }
  }
`;
